import React from 'react';
import './GeoErrorModal.css';

export default function GeoErrorModal({ error, onRetry, onClose }) {
  if (!error) return null;

  const { message, canRetry } = error;

  return (
    <div className="geo-modal-overlay">
      <div className="geo-modal">
        <div className="geo-modal-icon">⚠️</div>
        <h2 className="geo-modal-title">Location Verification Failed</h2>
        <p className="geo-modal-message">{message}</p>
        <div className="geo-modal-actions">
          {canRetry && (
            <button className="geo-modal-retry" onClick={onRetry}>
              Retry
            </button>
          )}
          <button className="geo-modal-close" onClick={onClose}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
